// extracted by mini-css-extract-plugin
module.exports = {"root":"LoaderDots_root__11kBI","dot":"LoaderDots_dot__yZlUA","bounce":"LoaderDots_bounce__3fyTb","color":"LoaderDots_color__1aL6i"};